// @ts-nocheck
import React from 'react';
import { DiJavascript1 } from 'react-icons/di';
import { FaReact } from 'react-icons/fa';
import { IoLogoPwa } from 'react-icons/io5';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const ProjectCard = ({
  project: { name, image, deployed_url, github_url, type },
}) => {
  function renderItem() {
    if (type === 'js') {
      return (
        <DiJavascript1
          className='projectCard__icon'
          style={{ color: '#FFDA33' }}
        />
      );
    } else if (type === 'react') {
      return (
        <FaReact className='projectCard__icon' style={{ color: '#0ED2FE' }} />
      );
    } else if (type === 'pwa') {
      return (
        <IoLogoPwa className='projectCard__icon' style={{ color: '#5A00CD' }} />
      );
    }
  }

  return (
    <div className='projectCard col-md-6 col-lg-4 my-2'>
      <figure className='projectCard__wrapper'>
        <a href={deployed_url} target='_blank' rel='noopener noreferrer'>
          <div>
            <LazyLoadImage
              effect='blur'
              src={image}
              alt={name}
              // placeholder='Loading...'
              placeholderSrc={image}
              className='projectCard__image'
              width='200px'
              height='100px'
            />
            <span>{image.caption}</span>
          </div>
        </a>
        <div className='projectCard__title'>
          <a href={github_url} target='_blank' rel='noopener noreferrer'>
            {renderItem()}
          </a>
          {name}
        </div>
      </figure>
    </div>
  );
};

export default ProjectCard;
